export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBoA4SykIT1GpFsEUy6hSOHPceG3cS9oG0",
    authDomain: "nzf-self-assessment.firebaseapp.com",
    projectId: "nzf-self-assessment",
    storageBucket: "nzf-self-assessment.firebasestorage.app",
    messagingSenderId: "963585719676",
    appId: "1:963585719676:web:be9d0d9f19ba817a4ab8f9",
    measurementId: "G-KGR4PHQT5Z"
  }
};